import { DateRange as MaterialDateRange } from '@angular/material/datepicker';
import { isDate, parseISO } from 'date-fns';
import { DateRange } from '../models/date-range/date-range.model';

export function materialDateRangeToDate(
  range: MaterialDateRange<Date | string>,
): DateRange | Date | null {
  if (!range.start && !range.end) {
    return null;
  }
  if (range.start && !range.end) {
    return isDate(range.start) ? range.start : parseISO(range.start);
  }

  const start = isDate(range.start) ? range.start : parseISO(range.start as string);
  const end = isDate(range.end) ? range.end : parseISO(range.end as string);

  return new DateRange(start, end, true, true);
}
